module.exports = __webpack_public_path__ + "img/btn_cancel3_jobmule.5bd9b05e.png";